import { c as _c } from "react/compiler-runtime";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import { NoResultsForQuery } from "./NoResultsForQuery";
interface SearchVariant {
  query: string;
}
interface Props {
  searchVariant?: SearchVariant;
  onClearAll?: () => void;
}
export function PlpEmptyResults(t0) {
  const $ = _c(8);
  const {
    searchVariant,
    onClearAll
  } = t0;
  if (searchVariant) {
    let t1;
    if ($[0] !== searchVariant.query) {
      t1 = <div className="flex flex-col items-center gap-4 py-16 text-center" data-testid="plp-empty-results-search"><NoResultsForQuery query={searchVariant.query} /></div>;
      $[0] = searchVariant.query;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <AlertTitle className="line-clamp-none text-base font-semibold">No products match your filters</AlertTitle>;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <p>Try removing a filter to see more options.</p>;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== onClearAll) {
    t3 = onClearAll && <Button onClick={onClearAll} variant="outline">Clear all filters</Button>;
    $[4] = onClearAll;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = <div className="flex flex-col items-center gap-4 py-16 text-center" data-testid="plp-empty-results"><Alert className="border-0 bg-transparent">{t1}<AlertDescription className="justify-items-center">{t2}{t3}</AlertDescription></Alert></div>;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}